export * from './device-detection.service';
export * from './device-detection.interface';
